import React from "react";
import PropTypes from "prop-types";
import {
	Box,
	CircularProgress,
	Container,
} from "@mui/material";

/**
 * AuthLoadingContainer component.
 *
 * Displays a circular progress indicator within a container to indicate a loading state.
 *
 * @component
 * @example
 * return (
 *   <AuthLoadingContainer />
 * )
 */
export default function AuthLoadingContainer() {
	return (
		<Box>
			<Container>
				<CircularProgress />
			</Container>
		</Box>
	);
}

AuthLoadingContainer.propTypes = {
};
